import * as React from 'react';
import {view} from '@sail/ui';
import {useIntl} from '@sail/intl';
import type {ExternalAccount} from './ExternalAccountConfirmation';
import {externalAccountMessages} from './ExternalAccountConfirmation';

type Props = {
  externalAccount: ExternalAccount;
};

const getMask = (externalAccount: ExternalAccount) => {
  switch (externalAccount.object) {
    case 'card':
      if (externalAccount.brand === 'American Express') {
        return '•••• •••••• • ';
      } else {
        return '•••• •••• •••• ';
      }
    case 'bank_account':
    default:
      return '•••• ';
  }
};

const formatExternalAccountNumberMask = (externalAccount: ExternalAccount) => {
  if (externalAccount.object === 'blockchain_address') {
    throw new Error(`Unexpected case: ${JSON.stringify(externalAccount)}`);
  }
  const mask = getMask(externalAccount);
  return `${mask}${externalAccount.last4}`;
};

export const PreviousExternalAccountNumber = ({externalAccount}: Props) => {
  const intl = useIntl();
  let formattedMessage: string;

  switch (externalAccount.object) {
    case 'bank_account':
      formattedMessage = intl.formatMessage(
        externalAccountMessages.previousAccountNumberLabel,
      );
      break;
    case 'card':
      formattedMessage = intl.formatMessage(
        externalAccountMessages.previousCardNumberLabel,
      );
      break;
    default:
      throw new Error(`Unexpected case: ${JSON.stringify(externalAccount)}`);
  }
  return (
    <view.div css={{color: 'text'}}>
      <view.strong>{formattedMessage}</view.strong>
      <br />
      <view.span>{formatExternalAccountNumberMask(externalAccount)}</view.span>
    </view.div>
  );
};
